import { isAnalyticsBlockedPath, sanitizeAnalyticsProperties, sanitizeAnalyticsValue } from 'src/app/util/analytics-url';

type SegmentMiddlewarePayload = {
  obj?: Record<string, unknown>;
};

type SegmentMiddlewareArgs = {
  payload: SegmentMiddlewarePayload;
  next: (payload: SegmentMiddlewarePayload) => void;
};

export function sanitizeSegmentEvent(event: Record<string, unknown>): Record<string, unknown> {
  const sanitized = { ...event };

  if (sanitized.properties && typeof sanitized.properties === 'object') {
    sanitized.properties = sanitizeAnalyticsProperties(sanitized.properties as Record<string, unknown>);
  }

  if (sanitized.context) {
    sanitized.context = sanitizeAnalyticsValue(sanitized.context);
  }

  if (sanitized.traits && typeof sanitized.traits === 'object') {
    sanitized.traits = sanitizeAnalyticsProperties(sanitized.traits as Record<string, unknown>);
  }

  return sanitized;
}

export function installSegmentSanitizationMiddleware(
  analytics: { addSourceMiddleware?: (fn: (args: SegmentMiddlewareArgs) => void) => void } | undefined,
): void {
  analytics?.addSourceMiddleware?.(({ payload, next }) => {
    if (payload?.obj) {
      payload.obj = sanitizeSegmentEvent(payload.obj);
    }
    next(payload);
  });
}

export function shouldLoadSegmentAnalytics(enableAnalytics: boolean, pathname = window.location.pathname): boolean {
  return enableAnalytics && !isAnalyticsBlockedPath(pathname);
}
